export default __webpack_public_path__ + "static/media/advisor.7e05aded.png";